import { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";

const TypewriterText = ({ phrases = [], typingSpeed = 60, deletingSpeed = 40, delayBetween = 1500 }) => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);
  const [offset, setOffset] = useState(0); // New state to track shift
  
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    // Keep the typing end point (cursor) in view on small screens
    if (textRef.current && containerRef.current) {
      const textWidth = textRef.current.scrollWidth;
      const containerWidth = containerRef.current.offsetWidth;
      
      if (textWidth > containerWidth) {
        // Shift left so the end of the text is always visible
        setOffset(containerWidth - textWidth - 5); // -5 for cursor space
      } else {
        setOffset(0);
      }
    }
  }, [displayedText]);

  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];
    let timeout;

    if (!isDeleting && displayedText.length < currentPhrase.length) {
      timeout = setTimeout(() => setDisplayedText(currentPhrase.slice(0, displayedText.length + 1)), typingSpeed);
    } else if (!isDeleting && displayedText.length === currentPhrase.length) {
      timeout = setTimeout(() => setIsDeleting(true), delayBetween);
    } else if (isDeleting && displayedText.length > 0) {
      timeout = setTimeout(() => setDisplayedText(currentPhrase.slice(0, displayedText.length - 1)), deletingSpeed);
    } else if (isDeleting && displayedText.length === 0) {
      setIsDeleting(false);
      setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
    }
    return () => clearTimeout(timeout);
  }, [displayedText, isDeleting, currentPhraseIndex, phrases]);

  return (
    <Box 
      ref={containerRef}
      sx={{ 
        width: "100%", 
        overflow: "hidden", 
        height: "40px", 
        display: "flex", 
        alignItems: "center" 
      }}
    >
      <Box
        ref={textRef}
        component="span"
        sx={{
          whiteSpace: "nowrap",
          fontFamily: "JetBrains Mono, monospace",
          fontSize: { xs: "1rem", md: "1.5rem" },
          color: "#e6edf3",
          borderRight: "2px solid #00ffff",
          paddingRight: "2px",
          transition: "transform 0.1s linear", // Smoothly follows typing
          transform: `translateX(${offset}px)`, // DYNAMIC SHIFT
          // Cursor blink
          animation: "blink 0.75s step-end infinite",
          "@keyframes blink": {
            "50%": { borderColor: "transparent" }
          }
        }}
      >
        {displayedText}
      </Box>
    </Box>
  );
};

export default TypewriterText;
